// import * as React from 'react';

// // @mui material components
// import Grid from "@mui/material/Grid";

// // Material Dashboard 2 React components
// import MDBox from "components/MDBox";

// // Material Dashboard 2 React example components
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
// import useApi from "../../../components/Utils/api";
// import { useNavigate } from "react-router-dom";
// import {QontoConnector, QontoStepIcon, ColorlibConnector, ColorlibStepIcon} from "./stepper";
// import Stack from '@mui/material/Stack';
// import Stepper from '@mui/material/Stepper';
// import Step from '@mui/material/Step';
// import StepLabel from '@mui/material/StepLabel';
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
// import { StepContent } from "@mui/material";
// import MerchantOfficeDetails from "../tabs/merchantOffficeDetails";
// import MerchantBankDetails from "../tabs/merchantBankDetails";
// import MerchantOtherDetails from "../tabs/merchantOtherDetails";
// import { useContext } from "react";
// import ValidationContext from "../../../context/validation";
// import { merchantSchemaStep1, merchantSchemaStep2, merchantSchemaStep3 } from "../../../models/merchantModel";
// import { FormProvider, useForm } from "react-hook-form";
// import { yupResolver } from '@hookform/resolvers/yup';
// import toast from "utils/toast";


// function NewMerchant() {
//   const navigate = useNavigate();

//   const api = useApi();
//   const [activeStep, setActiveStep] = React.useState(0);
//   const { register, handleSubmit, reset, formState: { errors }, trigger, watch, control } = useForm({
//     mode: "onChange",
//     resolver: yupResolver(activeStep === 0 ? merchantSchemaStep1 : activeStep === 1 ? merchantSchemaStep2 : activeStep === 2 ? merchantSchemaStep3 : {})
//   });
//   const [merchant, setMerchant] = React.useState({});
//   const [requiredInfo, setRequiredInfo] = React.useState({
//     mcclist : [],
//     cityList : [],
//     referenceCompany : [],
//     microAtm : []
//   })
  

//   const onSubmit = data => {
//     console.log("onSubmit called", data); // 👈 add this
//     // if(activeStep < 2 && Object.keys(errors).length === 0) {
//     //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
//     if (activeStep < 2) {
//       setActiveStep((prevActiveStep) => prevActiveStep + 1);
//     } else {
//       saveMerchant(data);
//     }
//   };
//   const saveMerchant = (data) => {
//     let formData = {...data, merchantCategoryCode: {
//         merchantCode: data.mccCode,
//         merchantDescription: "",
//         status: ""
//       }}
//     api.post("merchant/create", formData)
//       .then(response => {
//         if(response.data.statusCodeValue === 200){
//           toast.success(response.data.body.message);
//           navigate("/merchants/single", {
//             state: {
//               companyId: response.data.body.companyId
//             }
//           })
//         } else if(response.data.statusCodeValue === 409) {
//           toast.error(response.data.body);
//         }
//       })
//       .catch(error => {
//         console.log(error);
//       });
//   }
//   // const handleNext = () => {
//   //   console.log("Next clicked"); // 👈 add this
//   //   handleSubmit(onSubmit)();
//   // };
//   const handleNext = async () => {
//     console.log("Next clicked");

//     const isValid = await trigger();

//     console.log("Is Valid:", isValid);
//     console.log("Errors:", errors);

//     if (isValid) {
//       handleSubmit(onSubmit)();
//     }
//   };
//   const formValuesHandler = (e) => {
//     const {name, value} = e.target;
//     validateInput('NAME_BASED', name, value);
//     setMerchant({...merchant, merchant : {...merchant.merchant , [name]: value}});
//   }
//   const getAllRequiredInfo = () => {
//     api.get("merchant/getNewMerchReqInfo")
//       .then(response => {
//         if(response.data.statusCodeValue === 200){
//           setRequiredInfo(response.data.body);
//         }
//       })
//       .catch(error => {

//       })
//   }
//   React.useEffect(() => {
//     getAllRequiredInfo();
//   }, [])
//   const handleBack = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep - 1);
//   };
//   const steps = [
//     {
//       label: 'Merchant office details',
//       component: <MerchantOfficeDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new" errors={errors} register={register}/>
//     },
//     {
//       label: 'Merchant bank details',
//       component: <MerchantBankDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new"/>
//     },
//     {
//       label: 'Other details',
//       component: <MerchantOtherDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new"/>
//     }
//   ];


//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox mt={6} mb={3}>
//         <Grid container spacing={3} justifyContent="center">
//           <Grid item xs={12} lg={12}>
//             <Stack sx={{ width: '100%' }} spacing={4}>
//               <Stepper alternativeLabel style={{ background: 'unset', boxShadow: 'unset' }} activeStep={activeStep} connector={<ColorlibConnector />}>
//                 {steps.map((step, index) => (
//                   <Step key={step.label}>
//                     <StepLabel
//                       StepIconComponent={ColorlibStepIcon}
//                        sx={{
//                          '& .MuiStepLabel-label': {
//                            color: '#504d4d !important'
//                          },
//                          '& .MuiStepLabel-label.Mui-active': {
//                            color: '#000 !important'
//                          },
//                          '& .MuiStepLabel-label.Mui-completed': {
//                            color: '#000 !important'
//                          }
//                        }}
//                     >
//                       {step.label}
//                     </StepLabel>
//                   </Step>
//                 ))}
//               </Stepper>
//             </Stack>
//             <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, requiredInfo, control }}>
//             {steps.map((step, index) => (
//               <Box sx={{ p: 3 }} key={step.label} style={{ display: activeStep === index ? 'block' : 'none' }}>
//                 {step.component}
//               </Box>
//             ))}
//             </FormProvider>
//             <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
//               <Button
//                 color="inherit"
//                 disabled={activeStep === 0}
//                 onClick={handleBack}
//                 sx={{ mr: 1 }}
//               >
//                 Back
//               </Button>
//               <Box sx={{ flex: '1 1 auto' }} />
//               <Button onClick={handleNext}>
//                 {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
//               </Button>
//             </Box>
//           </Grid>
//         </Grid>
//       </MDBox>
//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default NewMerchant;


import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MerchantOfficeDetails from "../tabs/merchantOffficeDetails";
import MerchantBankDetails from "../tabs/merchantBankDetails";


import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { merchantSchemaStep1, merchantSchemaStep2 } from "../../../models/merchantModel";

import useApi from "../../../components/Utils/api";

const steps = ["Merchant Details", "Bank Details"];

function WizardSteps({ activeStep }) {
  return (
    <MDBox display="flex" alignItems="flex-start" mb={4} sx={{ maxWidth: "420px" }}>
      {steps.map((label, index) => {
        const isDone = index < activeStep;
        const isActive = index === activeStep;
        return (
          <MDBox
            key={label}
            flex={1}
            position="relative"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            {index < steps.length - 1 && (
              <MDBox
                sx={{
                  position: "absolute",
                  top: "17px",
                  left: "50%",
                  width: "100%",
                  height: "2px",
                  backgroundColor: isDone ? "info.main" : "grey.400",
                  zIndex: 0,
                }}
              />
            )}
            <MDBox
              width="34px"
              height="34px"
              borderRadius="50%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                position: "relative",
                zIndex: 1,
                border: "2px solid",
                borderColor: isActive || isDone ? "info.main" : "grey.400",
                backgroundColor: isActive || isDone ? "info.main" : "grey.100",
                color: isActive || isDone ? "white" : "grey.600",
                fontWeight: 700,
                fontSize: "0.8rem",
              }}
            >
              {index + 1}
            </MDBox>
            <MDTypography
              variant="caption"
              fontWeight="bold"
              color={isActive || isDone ? "dark" : "text"}
              sx={{ fontSize: "0.7rem", textAlign: "center", mt: 1 }}
            >
              {label}
            </MDTypography>
          </MDBox>
        );
      })}
    </MDBox>
  );
}
WizardSteps.propTypes = {
  activeStep: PropTypes.number.isRequired,
};

function NewMerchant() {
  const api = useApi();
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);

  const formMethods = useForm({
    mode: "onChange",
    resolver: yupResolver(activeStep === 0 ? merchantSchemaStep1 : merchantSchemaStep2),
    defaultValues: {},
  });

  const { handleSubmit, getValues } = formMethods;


  const { trigger } = formMethods;

  const handleNext = async () => {
    console.log("Next clicked");

    const isValid = await formMethods.trigger();

    console.log("isValid:", isValid);
    console.log("errors:", formMethods.formState.errors);

    if (!isValid) return;

    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    } else {
      formMethods.handleSubmit(onSubmit)();
    }
  };
  /* ===================== SUBMIT HANDLER ===================== */
  const onSubmit = (data) => {
    console.log("OnSubmit", data);
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
      return;
    }

    const merchantPayload = {
      recIdentifier:      data.recIdentifier,
      institutionNumber:  data.institutionNumber,
      clientNumber:       data.clientNumber,
      registrationNumber: data.registrationNumber,
      companyName:        data.companyName,
      tradeName:          data.tradeName,
      businessClass:      data.businessClass,
      product:            data.product,
      conditionSet:       data.conditionSet,
      addressLine1:       data.addressLine1,
      addressLine2:       data.addressLine2,
      addressLine3:       data.addressLine3,
      city:               data.city,
      postCode:           data.postCode,
      contactName:        data.contactName,
      bankAccount:        data.bankAccount,
      bankName:           data.bankName,
      ifscCode:           data.ifscCode,
      clientBranch:       data.clientBranch,
      mid:                data.mid,
      groupMid:           data.groupMid,
      mobileNo:           data.mobileNo,
      emailId:            data.emailId,
    };
    console.log("Creating merchant with payload: ", merchantPayload);
    api
      .post("/merchant/create", merchantPayload)
      .then(() => {
        toast.success("Merchant created successfully");
        navigate("/merchants");
      })
      .catch((error) => {
        toast.error("Failed to create merchant");
        console.error(error);
      });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <MDBox mb={3}>
          <MDTypography variant="h5" fontWeight="bold">
            Add merchant
          </MDTypography>
          <MDTypography variant="button" color="text" fontWeight="regular">
            Step {activeStep + 1} of {steps.length} · {steps[activeStep].toLowerCase()}
          </MDTypography>
        </MDBox>

        <WizardSteps activeStep={activeStep} />

        <FormProvider {...formMethods}>
          <Box>
            {activeStep === 0 && <MerchantOfficeDetails editmode type="new" />}
            {activeStep === 1 && <MerchantBankDetails editmode type="new" />}
          </Box>
        </FormProvider>

        <MDBox display="flex" justifyContent="space-between" mt={3} sx={{ maxWidth: "680px" }}>
          <MDButton
            variant="outlined"
            color="secondary"
            disabled={activeStep === 0}
            onClick={() => setActiveStep((s) => s - 1)}
          >
            Back
          </MDButton>

          <MDButton variant="gradient" color="info" onClick={handleNext}>
            {activeStep === steps.length - 1
              ? "Create Merchant"
              : `Next: ${steps[activeStep + 1].toLowerCase()}`}
            {activeStep !== steps.length - 1 && <Icon sx={{ ml: 0.5 }}>arrow_forward</Icon>}
          </MDButton>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewMerchant;